import React, { useEffect, useState } from "react";
import { notification } from 'antd';
import dayjs from 'dayjs';
import { DescriptionText } from "../../design";
import {
    SpWidget,
    SpWidgetWrapper,
} from "../../widgetDesign";
import {
    BASE_URLS,
    addPaymentWidgetChargeById,
    getPaymentWidgetById,
    getHealthCheck,
    getServerEncription,
    generateClientKeyPair,
    encryptData,
} from "../../api";
import { MESSAGES, PAYMENT_WIDGET_STATUSES, PAGES, TabNames, WIDGET_INTERVALS, INDIAN_STATES, NETBANKING_LIST, LPG_CUSTOMER } from "../../appconstants";
import { AmountDivideByHundred } from "../../helper";
import currencyFormatter from "../../utils/currencyformatter";
import WidgetInfo from './components/widgetInfo';
import EmploymentInfo from './components/employmentInfo';
import ThanksInfo from './components/thanksInfo';
import AchPayment from "../../components/achPaymentWithPlaid";
import CardPayment from "../../components/cardpayment/CardPayment";
import UpiPayment from "../../components/upipayment/UpiPayment";
import BankPayment from "../../components/bankpayment/BankPayment";
import NetBanking from "../../components/netbanking/NetBanking";
import RecaptchaModal from "../../components/recaptcha";
import UPIIMAGE from "../../assets/imgs/upiNotification.svg";

type Props = {
    history: {
        push: Function,
    },
}

const PaymentWidget = (props: Props) => {

    const { match: { params: { paymentwidgetlinkId } }, location: { pathname, search } } = props;
    const [isShowSpinner, setShowSpinner] = useState(false);
    const [payment, setPayment] = useState(null);
    const [step, setStep] = useState(0);
    const [submitBtnText, setSubmitBtnText] = useState(null);
    const [supportedPaymentTypes, setSupportedPaymentTypes] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [isTransactionSuccessModalOpen, setTransactionSuccessModalOpen] = useState(false);
    const [isTransactionModalOpen, setTransactionModalOpen] = useState(false);
    const [amount, setAmount] = useState(null);
    const [interval, setInterval] = useState('');
    const [remarks, setRemarks] = useState('');
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [employStatus, setEmployStatus] = useState(null);
    const [companyDonation, setCompanyDonation] = useState(null);
    const [phoneNumber, setPhoneNumber] = useState(null);
    const [selectedTab, setSelectedTab] = useState(parseInt(localStorage.getItem(`${paymentwidgetlinkId}-tap-index`) || 0));
    const [tabName, setTabName] = useState('');
    const [banksList, setBanksList] = useState(null);
    const [isTest, setIsTest] = useState(null);
    const [bankTypes, supportedBankTypes] = useState([null]);
    const [ipAddress, setIpAddress] = useState('');
    const [loading, setLoading] = useState(false);
    const fromWidget = sessionStorage.getItem('fromWidget');
    const [upiDownTime, setUpiDownTime] = useState(false);
    const [recaptchaModalVisible, setRecaptchaModalVisible] = useState(false);
    const [savedPaymentDetails, setSavedPaymentDetails] = useState(null);
    const [recaptchaPaymentType, setRecaptchaPaymentType] = useState(null);
    const [paymentLinkUpiGlobalRecaptcha, setPaymentLinkUpiGlobalRecaptcha] = useState(null);
    const accountGid = [
      'account-cdfe7eecff324778a88a2727177a1c8f'
    ];
    const [plaidPublicToken, setPlaidPublicToken] = useState(() => localStorage.getItem(`plaidPublicToken-${paymentwidgetlinkId}`) || undefined);

    const getData = async () => {
        const response = await fetch('https://api.ipify.org/?format=json');
        const data = await response.json();
        setIpAddress(data.ip);
    }

    useEffect(() => {
        localStorage.removeItem('widgetInfo');
        sessionStorage.removeItem('fromWidget');
        getData();
    }, []);

    useEffect(() => {
        getPaymentWidgetData();
    }, [paymentwidgetlinkId]);

    useEffect(() => {
        if (fromWidget) {
            setStep(3);
        }
    }, [fromWidget]);


    useEffect(() => {
        if (step === 2) {
            setLoading(true);
            window.location = `${PAGES.PAYMENT_WIDGET_PAY}/${paymentwidgetlinkId}/pay`;
        }
    }, [step]);

    useEffect(() => {
        setSupportedPaymentTypes(['CARD']);
    }, [payment]);

    useEffect(() => {
        setTabName(supportedPaymentTypes && supportedPaymentTypes[selectedTab]);
    }, [selectedTab, supportedPaymentTypes]);

    const getPaymentWidgetData = async () => {
        setShowSpinner(true);
        try {
            const value = await getPaymentWidgetById(paymentwidgetlinkId, null);
            if (value) {
                const { status } = value.paymentWidget;
                if (PAYMENT_WIDGET_STATUSES.ACTIVE !== status) {
                    props.history.push(`${pathname}/expired`);
                    return;
                }
                // if (value.account.integratedMerchant && LPG_CUSTOMER.includes(atob(value.account.integratedMerchant))) {
                //     const val = await getHealthCheck();
                //     if (val && val.status !== 'ACTIVE') {
                //         setUpiDownTime(true);
                //         notification.open({
                //             message: '',
                //             description: <img src={UPIIMAGE} alt="" />,
                //           });
                //     }
                //   }
                setPayment(value);
                if (value.account && value.account.portal) {
                    const portal = value.account.portal.test;
                    setIsTest(portal);
                    supportedBankTypes(value.account.supportedPaymentTypes);
                    if (portal) {
                        const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === true));
                        setBanksList(supportedBanks);
                    } else {
                        const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === false));
                        setBanksList(supportedBanks);
                    }
                }
            }
        } catch (e) {
            props.history.push(`${pathname}/error`);
        } finally {
            setShowSpinner(false)
        }
    };

    const getPaymentWidgetDataWithSearchValue = async () => {
        const params = new URLSearchParams(search);
        if (!params.get('secret')) {
            props.history.push(`${pathname}/error`);
            return;
        }
        setShowSpinner(true);
        try {
            const value = await getPaymentWidgetById(paymentwidgetlinkId, search);
            if (value) {
                const { status } = value.paymentWidget;
                setPayment(value)
                if (PAYMENT_WIDGET_STATUSES.ACTIVE === status) {
                    setTransactionModalOpen(false);
                    setTransactionSuccessModalOpen(true);
                    setTimeout(function () {
                        setStep(3);
                    }, 5000);
                }
            }
        } catch (reason) {
            try {
                const value = await getPaymentWidgetById(paymentwidgetlinkId);
                if (value) {
                    const { status } = value.paymentWidget;
                    if (PAYMENT_WIDGET_STATUSES.ACTIVE !== status) {
                        props.history.push(`${pathname}/expired`);
                        return;
                    }
                    setPayment(value);
                    if (value.account && value.account.portal) {
                        const portal = value.account.portal.test;
                        setIsTest(portal);
                        supportedBankTypes(value.account.supportedPaymentTypes);
                        if (portal) {
                            const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === true));
                            setBanksList(supportedBanks);
                        } else {
                            const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === false));
                            setBanksList(supportedBanks);
                        }
                    }
                }
            } catch (e) {
                props.history.push(`${pathname}/error`);
            }
            error(reason);
        } finally {
            setShowSpinner(false);
        }
    };

    const chargeByBank = async (data) => {
        const { customerGid, fundingSourceId } = data;
        const paymentMethod = {
            bank: {
                referenceId: fundingSourceId,
            },
            customerGid,
            type: "ACH"
        }
        await chargeById({ paymentMethodDetails: paymentMethod });
    };

    const error = reason => {
        setErrorMessage(null);
        if (!reason) return;
        const { data: { message }, status } = reason;
        setErrorMessage(message);
        if (status === 500) {
            setErrorMessage(MESSAGES.SETUP_INTENT.ERROR);
        }
        setTransactionModalOpen(false);
        const errorEl = document.getElementById("error");
        if (null !== errorEl) { errorEl.scrollIntoView(); }
    };

    const chargeById = async (paymentDetails, recaptchaToken = null) => {
        setTransactionModalOpen(true);
        try {
            const values = await getServerEncription(recaptchaToken);
            if (values?.public_key) {
                const keys = generateClientKeyPair();
                if (keys?.privateKey) {
                    const encriptedData = encryptData(JSON.stringify(paymentDetails), values.public_key, keys.privateKey, values.key_id);
                    const payload = {
                        publicKey: keys?.publicKey,
                        keyId: encriptedData?.keyId,
                        iv: encriptedData?.iv,
                        data: encriptedData?.encryptedData,
                    }
                    if (encriptedData?.keyId) {
                        const response = await addPaymentWidgetChargeById(paymentwidgetlinkId, payload);
                        const value = response?.data?.entity;
                        if (value) {
                            let paymentUrl;
                            let redirectUrl;
                            if (interval === 'ONETIME') {
                                paymentUrl = value.paymentSession;
                            } else if (interval !== 'ONETIME') {
                                paymentUrl = value.subscription;
                            }
                            if (paymentUrl) {
                                const { nextActionUrl } = paymentUrl;
                                redirectUrl = paymentUrl.returnUrl;
                                if (nextActionUrl) {
                                    window.location = nextActionUrl;
                                    return;
                                }
                            }
                            setTransactionModalOpen(false);
                            setTransactionSuccessModalOpen(true);
                            setTimeout(function () {
                                if (redirectUrl) {
                                    window.location = redirectUrl;
                                } else if (!redirectUrl) {
                                    setStep(step + 1);
                                }
                            }, 5000);
                            if (paymentwidgetlinkId) { localStorage.removeItem(`${paymentwidgetlinkId}-tap-index`) }
                        }
                    }
                }
            }
        } catch (reason) {
            if (reason?.status === 429){
                setSavedPaymentDetails(paymentDetails);
                setRecaptchaModalVisible(true);
                setTransactionModalOpen(false);
                return;
            }
            error(reason);
        }
    };

    const onGlobalCaptchaVerified = async (token) => {
        setRecaptchaModalVisible(false);
        switch (recaptchaPaymentType) {
        case TabNames.UPI:
            setPaymentLinkUpiGlobalRecaptcha(token);
            break;
        default:
            await chargeById(savedPaymentDetails, token);
        }
        setRecaptchaPaymentType(null);
    }

    const chargeByUpi = async (data) => {
        const { customer, paymentMethod } = data;
        const paymentData = {
            employeeEmail: email,
            employeeFirstName: firstName,
            employeeLastName: lastName,
            employmentStatus: employStatus,
            remarks: remarks,
            companyDonation: companyDonation,
            paymentMethodDetails: paymentMethod,
            interval: interval,
            amount: amount,
            customerDetails: {
                email: customer.email,
                name: customer.name,
                phoneNumber: customer.phoneNumber,
                taxId: 'NONE',
                taxStatus: 'TAXABLE',
            }
        };
        await chargeById(paymentData);
    };

    const chargeByAch = async (data) => {
        const { customer, paymentMethod } = data;
        const paymentData = {
            paymentMethodDetails: paymentMethod,
            customerDetails: {
                email: customer.email,
                name: customer.name,
                phoneNumber: customer.phoneNumber,
                taxId: 'NONE',
                taxStatus: 'TAXABLE',
            },
            interval: interval,
            amount: amount,
            employeeFirstName: firstName,
            employeeLastName: lastName,
            employeeEmail: email,
            remarks: remarks,
            employmentStatus: employStatus,
            isCompanyDonation: companyDonation,
        }
        await chargeById(paymentData);
    };

    const chargeByCard = async (data) => {
        const { paymentMethod } = data;
        const paymentData = {
            employeeEmail: email,
            employeeFirstName: firstName,
            employeeLastName: lastName,
            remarks: remarks,
            employmentStatus: employStatus,
            companyDonation: companyDonation,
            paymentMethodDetails: paymentMethod,
            interval: interval,
            amount: amount,
            customerDetails: {
                email: email,
                name: `${firstName} ${lastName}`,
                phoneNumber: phoneNumber,
                taxId: 'NONE',
                taxStatus: 'TAXABLE'
            }
        };
        const userAgent = {
            acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8",
            ip: ipAddress,
            language: window.navigator.language,
            colorDepth: window.screen.colorDepth,
            screenHeight: window.screen.height,
            screenWidth: window.screen.width,
            timeZone: new Date().getTimezoneOffset(),
            browserUserAgent: window.navigator.userAgent
        };
        paymentData.userAgent = userAgent;
        await chargeById(paymentData);
    };

    const chargeByNetBanking = async (data) => {
        const { gid } = data;
        const paymentMethod = {
            type: "NET_BANKING",
            netbanking: {
                swirepayBankGid: gid,
            },
        };
        const paymentData = {
            employeeEmail: email,
            employeeFirstName: firstName,
            employeeLastName: lastName,
            remarks: remarks,
            employmentStatus: employStatus,
            companyDonation: companyDonation,
            paymentMethodDetails: paymentMethod,
            interval: interval,
            amount: amount,
        };
        await chargeById(paymentData);
    };

    const amountInfo = (amountDetails: Object) => {
        setStep(step + 1);
        setAmount(amountDetails.amount);
        setInterval(amountDetails.interval);
        const selectedInterval = WIDGET_INTERVALS.find(value => value.value === amountDetails.interval);
        const interval = selectedInterval.name ? selectedInterval.name : '';
        setSupportedPaymentTypes(['CARD']);
        setSubmitBtnText(`${payment.paymentWidget.payButtonLabel} ${currencyFormatter(AmountDivideByHundred(amountDetails.amount), payment.account.currency.name)} ${interval}`)
    };

    const employmentInfo = (employDetails: Object) => {
        const widgetData = {
            amount,
            interval,
            email: employDetails.email,
            firstName: employDetails.firstName,
            lastName: employDetails.lastName,
            remarks: employDetails?.remarks,
            employmentStatus: employDetails.employmentStatus,
            comapnyDonation: employDetails.comapnyDonation,
            employDetails: employDetails.phone,
        }
        localStorage.setItem('widgetInfo', JSON.stringify(widgetData));
        setStep(step + 1);
        setEmail(employDetails.email);
        setFirstName(employDetails.firstName);
        setLastName(employDetails.lastName);
        setRemarks(employDetails?.remarks);
        setEmployStatus(employDetails.employmentStatus);
        setCompanyDonation(employDetails.comapnyDonation);
        setPhoneNumber(employDetails.phone);
    };

    const getPreviousTab = (employDetails: Object) => {
        payment.paymentWidget.defaultInterval = interval;
        payment.paymentWidget.selectedAmount = amount;
        payment.paymentWidget.employDetails = employDetails;
        setPayment(payment);
        setStep(step - 1);
    };

    const tabPanels = supportedPaymentTypes ? supportedPaymentTypes.reduce(function (panel, name) {
        let children;
        if (name === TabNames.ACH_LEGACY) {
            children = <AchPayment
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByAch}
                preFillCustomer={payment}
                customerDisabled={false}
                headerText={accountGid.includes(payment?.account?.gid) ? "Pay With BANK" : "Pay With ACH"}
                buttonText={submitBtnText}
                customerValidation={true}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                plaidPublicToken={plaidPublicToken}
                setPlaidPublicToken={setPlaidPublicToken}
                accountGid={payment?.account?.gid}
                paymentLinkId={paymentwidgetlinkId}
                isTest={payment?.account?.portal?.test}
                enableConsentCheckbox={true}
                accountName={payment?.account?.name}
                paymentDate={dayjs().format('MMMM D, YYYY')}
                finalPayAmount={typeof submitBtnText === 'string' && submitBtnText.slice(4)}
            />
        } else if (name === TabNames.CARD) {
            children = <CardPayment
                errorMsg={errorMessage}
                errorHeader={null}
                hideCustomer={true}
                customerReadOnly={false}
                submit={chargeByCard}
                preFillCustomer={payment}
                headerText={"Pay With Card"}
                buttonText={submitBtnText}
                isZipCodeRequired={(payment && payment.account && payment.account.collectCustomerAddress)}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                customerValidation={false}
                alpha2={payment && payment.account.currency && payment.account.currency.countryAlpha2}
                payments={payment}
            />
        } else if (name === TabNames.UPI) {
            children = <UpiPayment
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByUpi}
                preFillCustomer={payment}
                headerText={"Pay With UPI"}
                buttonText={submitBtnText}
                customerValidation={true}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                paymentWidget={true}
                setRecaptchaModalVisible={setRecaptchaModalVisible}
                setSavedPaymentDetails={setSavedPaymentDetails}
                savedPaymentDetails={savedPaymentDetails}
                globalRecaptchaToken={paymentLinkUpiGlobalRecaptcha}
                setGlobalRecaptchaToken={setPaymentLinkUpiGlobalRecaptcha}
                setRecaptchaPaymentType={setRecaptchaPaymentType}
                acquirer={payment?.acquirer}
            />
        } else if (name === TabNames.ACH) {
            children = <BankPayment
                errorMsg={errorMessage}
                errorHeader={null}
                customerDisabled={false}
                submit={chargeByBank}
                preFillCustomer={payment}
                headerText={"Pay With Bank Transfer"}
                buttonText={submitBtnText}
                paymentwidgetlinkId={paymentwidgetlinkId}
                iavUrl={`${BASE_URLS.PAYMENT_WIDGET}/${paymentwidgetlinkId}`}
                customerValidation={true}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
            />
        } else if (name === TabNames.NET_BANKING) {
            children = <NetBanking
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByNetBanking}
                preFillCustomer={payment}
                headerText={"PAY WITH NET BANKING"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                customerValidation={true}
                banksList={banksList}
                bankTypes={bankTypes}
                isTest={isTest}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
            />
        } else {
            children = <DescriptionText>Processing payment. Please wait...</DescriptionText>
        }
        panel.push({ children });
        return panel;
    }, []) : [
        {
            children: <CardPayment
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                hideCustomer={true}
                submit={chargeByCard}
                preFillCustomer={payment}
                headerText={"Pay With Card"}
                buttonText={submitBtnText}
                isZipCodeRequired={(payment && payment.account && payment.account.collectCustomerAddress)}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                customerValidation={false}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                payments={payment}
            />
        }
    ];

    if (loading) {
        return (
            <>
                <div style={{ marginLeft: '150px' }} className="spinner-border text-muted mr-4"> </div>
            </>
        )
    }

    return (
        <div>
            <SpWidget>
                <SpWidgetWrapper
                    style={{
                        marginTop: '10px',
                        marginBottom: '10px',
                        // height: (step === 2 && tabName === 'ACH_LEGACY' && '960px') || (step === 2 && tabName === 'UPI' && '760px') || (step === 2 && tabName === 'ACH' && '860px') || (step === 2 && tabName === 'CARD' && '760px'),
                    }}
                >
                    {
                        step === 0 && payment && (
                            <div style={{ textAlign: 'center' }}>
                                <WidgetInfo
                                    payment={payment}
                                    whiteLabel={payment && payment.account && payment.account.whiteLabel}
                                    amountInfo={amountInfo}
                                />
                            </div>
                        )
                    }
                    {
                        step === 1 && payment && (
                            <div style={{ textAlign: 'center' }}>
                                <EmploymentInfo
                                    payment={payment}
                                    employmentInfo={employmentInfo}
                                    whiteLabel={payment && payment.account && payment.account.whiteLabel}
                                    getPreviousTab={getPreviousTab}
                                />
                            </div>
                        )
                    }
                    {/* {
                        step === 2 && payment && (
                            <>
                                <PaymentMethodTabs
                                    name={paymentwidgetlinkId}
                                    paymentTypes={(payment && payment.account.currency && payment.account.currency.countryAlpha2)}
                                    tabs={getMenuTabs(supportedPaymentTypes)}
                                    tabPanels={tabPanels}
                                    defaultSelectedTab={selectedTab || 0}
                                    onSelect={data => setSelectedTab(data)}
                                    tabName={tabName}
                                />
                                <TransactionModal body={null} header={null} isOpen={isTransactionModalOpen} />
                                <SuccessModal isOpen={isTransactionSuccessModalOpen} />
                                <Spinner isOpen={isShowSpinner} />
                            </>
                        )
                    } */}
                    {
                        step === 3 && payment && (
                            <div style={{ textAlign: 'center' }}>
                                <ThanksInfo
                                    payment={payment}
                                />
                            </div>
                        )
                    }
                    
                </SpWidgetWrapper>
            </SpWidget>
            <RecaptchaModal
                visible={recaptchaModalVisible}
                onVerified={onGlobalCaptchaVerified}
            />
        </div>
    )
};

export default PaymentWidget;
